function e(e){return new SyntaxError(`Identifier '${e}' has already been declared`)}export{e as ErrDuplicateDeclard};
